var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAirPurifier(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10718_7811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.1709 13.4512V13.6418C1.1709 14.642 1.97689 15.4534 2.96985 15.4534H8.12892C9.1237 15.4534 9.92788 14.642 9.92788 13.6418V13.4512H1.1709Z",
    stroke: "#999999",
    strokeWidth: 1.08918,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.54905 5.53266C6.17966 5.53266 6.69087 5.02145 6.69087 4.39084C6.69087 3.76023 6.17966 3.24902 5.54905 3.24902C4.91844 3.24902 4.40723 3.76023 4.40723 4.39084C4.40723 5.02145 4.91844 5.53266 5.54905 5.53266Z",
    stroke: "#999999",
    strokeWidth: 1.08918,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5345 7.13081C10.5454 6.97106 10.5508 6.8095 10.5508 6.64794C10.5508 3.27694 8.31075 0.544922 5.54787 0.544922C2.78499 0.544922 0.544922 3.27694 0.544922 6.64794C0.544922 6.82584 0.552183 7.00011 0.56489 7.17438C0.555814 7.24699 0.550368 7.32141 0.550368 7.39766V11.64C0.550368 12.6402 1.3618 13.4517 2.36203 13.4517H8.7446C9.74483 13.4517 10.5563 12.6402 10.5563 11.64V7.39766C10.5563 7.30689 10.5472 7.21794 10.5345 7.13081Z",
    stroke: "#999999",
    strokeWidth: 1.08918,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10718_7811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.1005,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirPurifier);
export default __webpack_public_path__ + "static/media/AirPurifier.cea71164bf2bd158e523097bd62c4050.svg";
export { ForwardRef as ReactComponent };